"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH0_ORG_NAME_CLAIM = exports.AUTH0_ORG_ID_CLAIM = exports.AUTH0_CLAIM_NAMESPACE = exports.STAFF_ORG_USERNAME = void 0;
exports.isStaff = isStaff;
exports.assertNoStaffEscalation = assertNoStaffEscalation;
exports.accessibleOwnerIds = accessibleOwnerIds;
exports.adminOrgIds = adminOrgIds;
exports.isReservedOrgUsername = isReservedOrgUsername;
const authentication_types_1 = require("./authentication.types");
exports.STAFF_ORG_USERNAME = 'cadstrom';
exports.AUTH0_CLAIM_NAMESPACE = 'https://cadstrom.io';
exports.AUTH0_ORG_ID_CLAIM = `${exports.AUTH0_CLAIM_NAMESPACE}/org_id`;
exports.AUTH0_ORG_NAME_CLAIM = `${exports.AUTH0_CLAIM_NAMESPACE}/org_name`;
function isStaff(session) {
    if (session.actor.type !== authentication_types_1.ActorType.User) {
        return false;
    }
    return session.memberships.some((m) => m.groupUsername === exports.STAFF_ORG_USERNAME);
}
function assertNoStaffEscalation(session) {
    if (session.actor.type === authentication_types_1.ActorType.User || session.abilities === undefined) {
        return;
    }
    for (const [scope, ability] of session.abilities) {
        for (const rule of ability.rules) {
            const actions = Array.isArray(rule.action) ? rule.action : [rule.action];
            const subjects = Array.isArray(rule.subject) ? rule.subject : [rule.subject];
            const isManageAll = !rule.inverted && actions.includes('manage') && subjects.includes('all');
            const conditionCount = rule.conditions === undefined ? 0 : Object.keys(rule.conditions).length;
            if (isManageAll && conditionCount === 0) {
                throw new Error(`Non-user actor '${session.actor.userId}' has staff-shaped permissions ` +
                    `(unconditioned manage-all rule in scope "${scope}")`);
            }
        }
    }
}
function accessibleOwnerIds(session, options) {
    const memberships = options?.excludeTrainees === true ?
        session.memberships.filter((m) => m.role !== authentication_types_1.MembershipRole.Trainee)
        : session.memberships;
    return [session.actor.userId, ...memberships.map((m) => m.groupId)];
}
function adminOrgIds(session) {
    return session.memberships.filter((m) => m.role === authentication_types_1.MembershipRole.Admin).map((m) => m.groupId);
}
function isReservedOrgUsername(username) {
    return username.toLowerCase() === exports.STAFF_ORG_USERNAME;
}
//# sourceMappingURL=session.js.map